import { render, staticRenderFns } from "./BoardSettingSub.vue?vue&type=template&id=2053f5d6&"
import script from "./BoardSettingSub.vue?vue&type=script&lang=ts&"
export * from "./BoardSettingSub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports